import { store } from 'app/redux/store';

const uri = "asonika://";

const sendClientCommand = (command: string) => {
    //TODO типизация store redux
    let state = store.getState().user;

    window.location.href = `${uri + command}/-token/${state.user.jwtToken}`;
}

export { sendClientCommand }